// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__2SJXo","title":"AfterImages90_title__3zNoa","images":"AfterImages90_images__7Vhsd"};